<template>
    <v-container v-if="link_loading||error_loading" fluid class="fill-height">
        <v-row align="center" justify="center">
            <v-col class="text-center">
                <div v-if="error_loading" class="display-1" style="color: #808080">
                    Не удалось загрузить страницу...
                </div>
                <v-progress-circular
                    v-else
                    indeterminate
                    size="90"
                    width="3"
                    color="dark">
                </v-progress-circular>
            </v-col>
        </v-row>
    </v-container>
    <div v-else>
        <v-toolbar dark>
            <v-toolbar-title>
                <v-icon large left>{{ icon_bag }}</v-icon>
                {{ opened_link.place }}
            </v-toolbar-title>
        </v-toolbar>
        <v-container v-if="opened_link.description" fluid>
            <v-row>
                <v-col class="py-0" cols="12">
                    <v-alert outlined type="info">
                        {{ opened_link.description }}
                    </v-alert>
                </v-col>
            </v-row>
        </v-container>
        <v-container v-if="loading" fluid>
            <v-row style="height: 40vh" justify="center" align="center">
                <v-col cols="12" class="text-center">
                    <div v-if="error_order_loading" class="display-1" style="color: #808080">
                        Не удалось загрузить заказы...
                    </div>
                    <v-progress-circular
                        v-else
                        indeterminate
                        size="60"
                        width="3"
                        color="dark">
                    </v-progress-circular>
                </v-col>
            </v-row>
        </v-container>
        <infinity-load v-else :next_page="next_page"
                       @loadnext="onLoadNextOrders">
            <order-list>
                <shared-collection
                    v-for="(collection, index) in sorted_collections"
                    :index="index"
                    :collection="collection"
                    :key="collection.id">
                </shared-collection>
                <shared-order
                    v-for="(order, index) in sorted_orders"
                    :index="index"
                    :value="order"
                    :key="order.id">
                </shared-order>
            </order-list>
        </infinity-load>

        <image-dialog/>
        <socket name="Market" :path="`purchases/market/${opened_link.purchase}/`" @onmessage="onSocketMessage"/>
    </div>
</template>

<script>
import {mapActions, mapGetters, mapState} from "vuex";
import {mdiBagChecked} from "@mdi/js";
import InfinityLoad from "../utils/InfinityLoad";
import OrderList from "../orders/OrderList";
import SharedOrder from "./SharedOrder";
import ImageDialog from "../utils/ImageDialog";
import SharedCollection from "./SharedCollection";
import Socket from "../utils/Socket";

export default {
    name: "SharedPage",
    components: {Socket, SharedCollection, ImageDialog, SharedOrder, OrderList, InfinityLoad},
    props: {
        uuid: {
            required: true,
        }
    },
    data() {
        return {
            icon_bag: mdiBagChecked,
            link_loading: true,
            error_loading: false,
            error_order_loading: false,
        }
    },
    computed: {
        ...mapGetters('links', [
            'opened_link'
        ]),
        ...mapState('orders', {
            'orders': 'orders',
            'loading_orders': 'loading_orders',
            'next_orders': 'next_page',
        }),
        ...mapState('collections', {
            'loading_collections': 'loading_collections',
            'collections': 'collections',
            'next_collections': 'next_page',
        }),
        loading() {
            return this.loading_collections || this.loading_orders && this.collections.length === 0;
        },
        next_page() {
            return this.next_collections !== null || this.next_orders !== null || this.next_orders === undefined;
        },
        sorted_orders() {
            return [...this.orders].filter(
                obj => {
                    let index = -1;
                    if (obj.replacements) {
                        index = obj.replacements.findIndex(item => {
                            return (item.collected && !item.places.includes(this.opened_link.place))
                        });
                    }
                    return !(obj.collected && !obj.places.includes(this.opened_link.place)) && index === -1
                }
            )
        },
        sorted_collections() {
            return [...this.collections].filter(
                obj => {
                    return !(obj.collected && !obj.places.includes(this.opened_link.place))
                }
            )
        }
    },
    methods: {
        ...mapActions('collections', [
            'getSharedCollections'
        ]),
        ...mapActions('orders', [
            'getSharedOrders'
        ]),
        ...mapActions('links', [
            'getShareLink'
        ]),
        onSocketMessage({type, data}) {
            switch (type) {
                case 'orders_collected':
                case 'orders_edit':
                    if (["P", "O", "F"].includes(data.state)) {
                        this.$store.commit('orders/deleteOrder', data)
                    } else {
                        this.$store.commit('orders/updateOrder', data);
                    }
                    break;
                case 'orders_delete':
                    this.$store.commit('orders/deleteOrder', data);
                    break;
                case 'collections_collected':
                case 'collections_edit':
                    if (["P", "O", "F"].includes(data.state)) {
                        this.$store.commit('orders/deleteOrder', data)
                    } else {
                        this.$store.commit('collections/updateCollection', data);
                    }
                    break;
                case 'collections_delete':
                    this.$store.commit('collections/deleteCollection', data.id);
                    break;
            }
        },
        onLoadNextOrders() {
            if (this.next_collections !== null) {
                this.getSharedCollections({uuid: this.opened_link.uuid})
            } else {
                this.getSharedOrders({uuid: this.opened_link.uuid});
            }
        },
    },
    created() {
        this.error_loading = false;
        this.link_loading = true;
        this.$store.commit('links/setOpenedLink', this.uuid)
        this.$store.dispatch('links/getShareLink', {uuid: this.uuid})
            .then(() => {
                document.title = this.opened_link.place

                this.getSharedCollections({uuid: this.opened_link.uuid})
                    .catch(() => {
                        this.error_order_loading = true;
                    })
                    .then(() => {
                        if (this.next_collections === null) {
                            this.getSharedOrders({uuid: this.opened_link.uuid})
                                .catch(() => {
                                    this.error_order_loading = true;
                                });
                        }
                    })

                this.link_loading = false;
            })
            .catch(() => {
                this.error_loading = true;
            })
    },
    destroyed() {
        this.$store.commit('collections/clearData');
        this.$store.commit('orders/clearData');
    }
}
</script>

<style scoped>

</style>